import { render, staticRenderFns } from "./prod-list.vue?vue&type=template&id=47ee24c4&scoped=true"
import script from "./prod-list.vue?vue&type=script&lang=js"
export * from "./prod-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ee24c4",
  null
  
)

export default component.exports